<script>
import Collapsible from '@/components/Collapsible'
import Checkbox from '@/components/Checkbox'
import DialogUtils from '@/utils/dialogUtils'
import vue from 'vue'

export default
{
    name: 'card-list-collapsible',

    props:
    {
        title: { type: String },
        description: { type: String },
        cardData: { type: Object, required: true },
        expanded: { type: Boolean },
        tagsDefinitions: { type: Array, required: true },
        tagsValidator: { type: Function },
    },

    created ()
    {
        this.isExpanded = this.expanded
    },

    render () 
    {
        const cardDataTags = vue.observable(Object.fromEntries(this.tagsDefinitions.map(t => [t.id, this.cardData.tags.includes(t.id)])))

        const setReportTag = (tag, val) =>
        {
            cardDataTags[tag.id] = val

            if (this.tagsValidator)
            {
                this.tagsValidator(tag.id, cardDataTags, this.cardData)
            }
        }

        const setLabelsDialogContent =
            <div>
                { this.tagsDefinitions.map(t => <checkbox icon={require(`@/assets/img/${t.icon.name}.svg`)} label={t.name}
                    v-model={cardDataTags[t.id]} on-input={val => setReportTag(t, val)} />) }
            </div>

        const createSetLabelsDialog = async () =>
        {
            const dialog = DialogUtils.showDialog({ title: 'Marquer comme :', description: setLabelsDialogContent, customClass: 'set-tags' })
            await dialog.waitForCloseAsync()
            const tags = Object.keys(cardDataTags).filter(tagId => cardDataTags[tagId])
            this.$emit('tags-set', tags)
        }
        const setLabelsIcon =
            <div class='set-tags-action' on-click={createSetLabelsDialog}>
                <inline-svg src={require('@/assets/img/tag.svg')} />
            </div>

        return (
            <collapsible class='card-list-collapsible' title={this.title} description={this.description} actions={setLabelsIcon}
                expanded={this.isExpanded} >
                { this.$slots.default }
            </collapsible>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            isExpanded: null
        }
    },

    computed:
    {
    },

    watch:
    {
        expanded ()
        {
            this.isExpanded = this.expanded
        }
    },

    methods:
    {
    },

    components:
    {
        Collapsible,
        Checkbox,
    }
}
</script>

<style lang='less'>
.dialog.set-tags
{
    .checkbox
    {
        &:not(:first-of-type)
        {
            margin-top: 6px;
        }
    }
}
</style>

<style lang='less'>
@import '~@/styles/main.less';

.card-list-collapsible
{
    margin-bottom: 10px;

    .header > .actions
    {
        .set-tags-action
        {
            .WidthHeight(20px);
            margin-left: auto;
            fill: var(--theme-background-text-color-heavy);
        }
    }

    .card-picture
    {
        width: 100%;
        max-height: 300px;
    }

    .markable
    {
        display: inline-block;
    }

    .section
    {
        margin-top: 5%;
        margin-bottom: 2%;
        font-size: inherit;

        & .title
        {
            font-size: 15px;
            margin-bottom: 5px;
            margin-top: 10px;
            font-weight: 500;
        }

        &.action-buttons
        {
            .OnTablet({
                display: flex;
                flex-direction: row;
            });

            .button
            {
                width: 100%;
                margin-left: 1%;
                margin-right: 1%;
                margin-top: 5px;

                &:first-of-type
                {
                    margin-top: 0;
                }

                .OnTablet({ margin-top: 0; })
            }
        }

        strong
        {
            font-weight: 500;
        }
    }

    .date
    {
        margin-top: 2%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/CardListCollapsible.vue